import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../utils/Loader';
import { setStatFilters } from '../../action/statistics';
import { isEmpty } from 'lodash';
import Select from 'react-select';
import { categoriesRawByType, loaderRawsSelector, rawListSelector } from '../../selectors/raw';
import { fetchProductCategories, fetchRawsList } from '../../action/raw';
import ReactPaginate from 'react-paginate';
import { categoryListSelector } from '../../selectors/goods';
import { fetchCategories, fetchGoods } from '../../action';
import { getGoodsWithReceipe, getGoodWithReceipeData } from '../../action/recipes';
import { MEASURES_RAW } from '../../containers/rawmaterials/constansts';
import {utils, writeFileXLSX} from "xlsx";
import moment from 'moment';
import { fetchFilials } from '../../action/handbook';
import request from '../../action/utils/request';
import { urls } from '../../constants/app';
import { parseNumToFixed, roundToFixed } from '../../utils/common';

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class Costprice extends Component {
    state = {
        currentPage: 0,
        data: null,
        count: 0,
        renderFields: true,
        typeReceipe: 'receipe',
        loadingData: false,
        error: null,
        rawsPrices: {},
        loadingPrices: false,
    }

    async getLastInvoice(rawId) {
        const { point } = this.props.costprice.filters;
        const params = {
            point,
            _sort: 'date:desc',
            ignoreBalance: true,
            rawId,
        };

        let result;

        try {
            result = await request({ method: 'get', url: `${urls.invoiceforms}/getNotRealizationInventory`, params});
        } catch (err) {
            return;
        }
        if (result && !result.error) return result;
        return;
    }

    getRawPrice = async (raw) => {
        const { rawsPrices } = this.state;
        const { point } = this.props.costprice.filters;
        
        const key = point ? `${raw.id}_${point}` : raw.id;
        
        if (rawsPrices[key]) return rawsPrices[key];

        let price = roundToFixed(raw.last_price, 4);

        if (!point) {
            const updated = { ...rawsPrices, [key]: price };
            this.setState({ rawsPrices: updated });
            return price;
        }

        const invoice = await this.getLastInvoice(raw.id);
        if (!invoice) {
            const updated = { ...rawsPrices, [key]: price };
            this.setState({ rawsPrices: updated });
            return price;
        }

        const rawData = invoice.rawMaterials.find((item) => item.id === raw.id);
        if (!rawData) {
            const updated = { ...rawsPrices, [key]: price };
            this.setState({ rawsPrices: updated });
            return price;
        }

        price = roundToFixed(rawData.price, 4);
        const updated = { ...rawsPrices, [key]: price };
        this.setState({ rawsPrices: updated });

        return price;
    }

    getAllRawPrices = async (goods) => {
        const rawIds = new Set();
        
        goods.forEach((good) => {
            if (good.receipeData) {
                good.receipeData.forEach(item => {
                    if (item.id) rawIds.add(item.id);
                });
            }
            if (good && good.receipe && good.receipe.ingredients) {
                good.receipe.ingredients.forEach((ingredient) => {
                    if (ingredient.type === 'raw' && ingredient.id) {
                        rawIds.add(ingredient.id);
                    }
                });
            }
        });

        const rawsPrices = {};
        const rawArray = Array.from(rawIds);
        
        for (let i = 0; i < rawArray.length; i++) {
            const rawId = rawArray[i];
            const raw = this.props.raws.find((item) => item.id === rawId);
            if (raw) {
                const price = await this.getRawPrice(raw);
                const key = this.props.costprice.filters.point ? `${raw.id}_${this.props.costprice.filters.point}` : raw.id; 
                rawsPrices[key] = price;
            }
        }

        return rawsPrices;
    }

    onChangeType = (e) => {
        if (e.value === 'semi' && isEmpty(this.props.productCategories)) this.props.fetchProductCategories();
        if (e.value === 'good' && isEmpty(this.props.categories)) this.props.fetchCategories();
        const { filters } = this.props.costprice;
        const updated = { ...filters, type: e.value, category: null };
        this.props.setStatFilters('costprice', updated);
    }

    getRegionPrice(good) {
        const { filters } = this.props.costprice;
        let price = parseNumToFixed(good.price);
        if (filters.point && good.regionprices && good.regionprices.length > 0) {
            const point = this.props.filials.find((item) => item.id === filters.point);
            if (point) {
                const cityId = point.city.id;
                const regionprice = good.regionprices.find((rprice) => rprice.cities.some((item) => parseInt(item.id) === cityId));
                if (regionprice) price = this.getModPrice(good.price, regionprice);
            }
        }
        return price;
    }

    onSearch = async () => {
        const { filters } = this.props.costprice;
        this.setState({ loadingData: true, loadingPrices: true });
        
        const data = await this.props.getGoodsWithReceipe();
        if (data.error) return this.setState({ 
            error: data.error.data, 
            loadingData: false, 
            loadingPrices: false 
        });
        
        const goods = data.goods;
        const count = data.count;
    
        const goodsWithReceipeData = await Promise.all(goods.map(async (good) => {
            const receipeData = good.receipeData ? good.receipeData : await this.props.getGoodWithReceipeData(good);
            if (good.receipe && good.receipe.ingredients) {
                const ingredientsWithReceipeData = await Promise.all(good.receipe.ingredients.map(async (ingredient) => {
                    if (ingredient.type !== 'raw') {
                        const ingredientReceipeData = await this.props.getGoodWithReceipeData(ingredient, true);
                        return { ...ingredient, receipeData: ingredientReceipeData };
                    }
                    return ingredient;
                }));
                good.receipe.ingredients = ingredientsWithReceipeData;
            }
            return { ...good, receipeData };
        }));

        const newRawPrices = await this.getAllRawPrices(goodsWithReceipeData);
        this.setState({ 
            rawsPrices: { ...this.state.rawsPrices, ...newRawPrices },
            loadingPrices: false 
        });

        const resultGoods = goodsWithReceipeData.flatMap((good) => {
            const price = this.getRegionPrice(good);            

            if (!good.modifications || good.modifications.length === 0) return [{...good, price}];
            return good.modifications.map((mod) => {
                const name = `${good.name} ${mod.title || ''}`
                if (mod.default) return {...good, price, name};
                return {...good, price, name, idMod: mod.id}
            });
        });
    
        this.setState({ 
            data: resultGoods, 
            count, 
            renderFields: filters.type === 'good', 
            loadingData: false, 
            error: null 
        });
    }

    onExport = async () => {
        const { type, point } = this.props.costprice.filters;
        const data = await this.props.getGoodsWithReceipe(null, true);
        const filial = point ? this.props.filials.find((item) => item.id === point) : null;

        const exportData = data.goods.flatMap((good) => {
            if (!good.modifications || good.modifications.length === 0) {
                const costprice = this.getCostPriceGood(good.receipeData, 'default') || '-';
                let item = {
                    'id': good.id || '-',
                    'Наименования': good.name,
                    'Себестоимость': costprice,
                }
                if (type === 'good') {
                    const price = this.getRegionPrice(good);
                    
                    item = {
                        ...item,
                        'Цена': price,
                        'Маржа': this.getMarginGood(good.price, costprice) || '-',
                        'Наценка (%)': this.getExtrachargeGood(good.price, costprice) || '-',
                        'Себестоимость': costprice,
                    }
                }
                return [item];
            }
            return good.modifications.map((mod) => {
                const costprice = this.getCostPriceGood(good.receipeData, !mod.default ? mod.id : 'default') || '-';
                let item = {
                    'id': (mod.default ? good.id : `${good.id}_${mod.id}`) || '-',
                    'Наименования': `${good.name} ${mod.title}`,
                    'Себестоимость': costprice,                    
                }
                if (type === 'good') {
                    let dataPrice = this.getRegionPrice(good);
                    
                    const price = !mod.default ? this.getPriceGood({...good, price: dataPrice}, mod.id) : dataPrice;
                    item = {
                        ...item,
                        'Цена': price,
                        'Маржа': this.getMarginGood(price, costprice) || '-',
                        'Наценка (%)': this.getExtrachargeGood(price, costprice) || '-',
                        'Себестоимость': costprice,                    
                    }
                }

                return item;
            })
        });
        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Себестоимость");

        writeFileXLSX(wb, `Себестоимость ${type === 'good' ? 'товары' : 'полуфабрикаты'} ${this.renderPointLabel(filial)} ${moment().format('DD-MM-YYYY')}.xlsx`);
    }

    renderName = (item, type) => {
        let categoryText;
        let typeText;

        if (type === 'good') {
            typeText = '(товар)';
            categoryText = (item.category && item.category.title) ? item.category.title : null;
        } else {
            if (type === 'raw') {
                typeText = '(сырье)';
            } else {
                typeText = '(п/ф)';
            }
            categoryText = (item.productscategory && item.productscategory.title) ? item.productscategory.title : null;
        }

        return categoryText ? `${categoryText}: ${item.name || `Наименование продукта id ${item.id} не определено`} ${typeText}` : `${item.name || `Наименование продукта id ${item.id} не определено`} ${typeText}`
    }

    getExportDataIngredients = async (receipe, idMod = 'default') => {
        if (!receipe || isEmpty(receipe.ingredients)) return null;

        const result = await Promise.all(receipe.ingredients.map(async (ingredient) => {
            const receipeData = ingredient.receipeData;
            const arr = ingredient.type === 'good' ? this.props.goodsList : this.props.raws;
            const partsId = typeof ingredient.id === 'string' ? ingredient.id.split('_') : null;
            const id = (partsId && partsId[0]) ? parseInt(partsId[0]) : ingredient.id;
            const modId = (partsId && partsId[1]) ? parseInt(partsId[1]) : null;

            let item = arr.find((el) => el.id === id);
            if (!item) item = ingredient;

            let costprice = null;
            if (ingredient.type === 'raw') {
                const key = this.props.costprice.filters.point ? `${item.id}_${this.props.costprice.filters.point}` : item.id;
                costprice = roundToFixed(this.state.rawsPrices[key], 4) || roundToFixed(item.last_price, 4);
            } else {
                costprice = this.getCostPriceGood(receipeData, idMod);
            }

            const quantity = roundToFixed(ingredient.quantity[idMod], 3) || 0;
            if (quantity === 0) return null;
            const sum = (!costprice || !quantity) ? '-' : roundToFixed(costprice * quantity, 4);

            const getIngredientName = (good, modId, type) => {
                if (isEmpty(good.modifications)) return this.renderName(good, type);
    
                let mod = null;
                if (modId) {
                    mod = good.modifications.find((item) => item.id === modId);
                } else {
                    mod = good.modifications.find((item) => item.default);
                }
                
                if (!mod) return this.renderName(good, type);
                return `${this.renderName(good, type)} ${mod.title || `Наименование модификации id ${modId} не определено`}`
            }

            return {
                id: item.id,
                name: getIngredientName(item, modId, ingredient.type),
                quantity,
                measure: MEASURES_RAW[item.measure] || '',
                sum,
                costprice,
            };
        }));
        
        return result.filter((item) => item);
    }

    getExportDataRaws = async (receipeData, idMod = 'default') => {
        if (!receipeData) return null;
        let items = {};
        
        receipeData.forEach((ingredient) => {
            let data = items[ingredient.id] || null;
            const raw = this.props.raws.find((item) => item.id === ingredient.id);
            
            if (!data) {
                const key = this.props.costprice.filters.point ? `${ingredient.id}_${this.props.costprice.filters.point}` : ingredient.id;
                const price = roundToFixed(this.state.rawsPrices[key], 4) || (raw ? roundToFixed(raw.last_price, 4) : null);
                
                data = {
                    id: ingredient.id,
                    name: raw ? raw.name : ingredient.name || 'DELETED',
                    measure: raw ? raw.measure : null,
                    last_price: price,
                    quantity: 0,
                };
            }

            if (ingredient.count && (ingredient.count[idMod] != null)) {
                data.quantity += roundToFixed(ingredient.count[idMod], 3) || 0;
            } else {
                data.quantity += roundToFixed(ingredient.quantity[idMod], 3) || 0;
            };
            items[ingredient.id] = data;
        });
        
        return Object.values(items).map((item) => {
            const price = roundToFixed(item.last_price, 2) || 0;
            const sum = (!price || !item.quantity) ? '-' : roundToFixed(price * roundToFixed(item.quantity, 3), 4);

            return {
                id: item.id,
                name: item.name,
                quantity: item.quantity,
                measure: MEASURES_RAW[item.measure] || '',
                sum: sum,
                last_price: item.last_price,
                costprice: roundToFixed(item.last_price, 4) || '-'
            };
        });
    }

    onExportWithIngredients = async () => {
        const { type, point } = this.props.costprice.filters;
        const data = await this.props.getGoodsWithReceipe(null, true);
        if (data.error) return this.setState({ error: data.error.data });
        const goods = data.goods;
    
        const goodsWithReceipeData = await Promise.all(goods.map(async (good) => {
            const receipeData = await this.props.getGoodWithReceipeData(good);
            if (good.receipe && good.receipe.ingredients) {
                const ingredientsWithReceipeData = await Promise.all(good.receipe.ingredients.map(async (ingredient) => {
                    if (ingredient.type !== 'raw') {
                        const ingredientReceipeData = await this.props.getGoodWithReceipeData(ingredient);
                        return { ...ingredient, receipeData: ingredientReceipeData };
                    }
                    return ingredient;
                }));
                good.receipe.ingredients = ingredientsWithReceipeData;
            }
            return { ...good, receipeData };
        }));

        const newRawPrices = await this.getAllRawPrices(goodsWithReceipeData);
        this.setState({ rawsPrices: { ...this.state.rawsPrices, ...newRawPrices }});

        const goodsWithIngredients = (await Promise.all(goodsWithReceipeData.flatMap(async (good) => {
            const dataPrice = this.getRegionPrice(good);
            if (!good.modifications || good.modifications.length === 0) {
                const costprice = this.getCostPriceGood(good.receipeData, 'default') || '-';

                let item = {
                    id: good.id,
                    name: good.name,
                    costprice,
                    ingredientsData: await this.getExportDataIngredients(good.receipe, 'default'),
                };

                if (type === 'good') {
                    item = {
                        ...item,
                        price: dataPrice,
                        margin: this.getMarginGood(dataPrice, costprice) || '-',
                        extracharge: this.getExtrachargeGood(dataPrice, costprice) || '-',
                    }
                }

                return [item];
            }
            
            const modItems = await Promise.all(good.modifications.map(async (mod) => {
                const idMod = !mod.default ? mod.id : 'default';
                const price = this.getPriceGood({ ...good, price: dataPrice }, idMod);
                const costprice = this.getCostPriceGood(good.receipeData, idMod) || '-';

                let item = {
                    id: mod.default ? good.id : `${good.id}_${mod.id}`,
                    name: `${good.name} ${mod.title}`,
                    costprice,
                    ingredientsData: await this.getExportDataIngredients(good.receipe, idMod),
                };

                if (type === 'good') {
                    item = {
                        ...item,
                        price: price,
                        margin: this.getMarginGood(price, costprice) || '-',
                        extracharge: this.getExtrachargeGood(price, costprice) || '-',
                    }
                }

                return item;
            }));
            
            return modItems;
        }))).flat();

        const exportData = goodsWithIngredients.flatMap((good) => {
            if (!good.ingredientsData || good.ingredientsData.length === 0) {
                let item = {
                    'id': good.id || '-',
                    'Наименования': good.name,
                    'Себестоимость': good.costprice,
                    'id Ингредиента': '-',
                    'Ингредиент': '-',
                    'Ед. изм. ингредиента': '-',
                    'Количество ингредиента': '-',
                    'Себестоимость ингредиента': '-',
                    'Сумма за ингредиент': '-',
                }
                if (type === 'good') {
                    item = {
                        ...item,
                        'Цена': good.price || '-',
                        'Маржа': good.margin || '-',
                        'Наценка (%)': good.extracharge || '-',
                        'Себестоимость': good.costprice,
                    }
                }
                return [item];
            }

            return good.ingredientsData.map((raw) => {
                let item = {}
                if (type === 'good') {
                    item = {
                        'id': good.id || '-',
                        'Наименования': good.name,
                        'Цена': good.price || '-',
                        'Маржа': good.margin || '-',
                        'Наценка (%)': good.extracharge || '-',
                        'Себестоимость': good.costprice,
                        'id Ингредиента': raw.id || '-',
                        'Ингредиент': raw.name,
                        'Ед. изм. ингредиента': raw.measure,
                        'Количество ингредиента': roundToFixed(raw.quantity, 3),
                        'Себестоимость ингредиента': roundToFixed(raw.costprice, 4),
                        'Сумма за ингредиент': roundToFixed(raw.sum, 4),
                    }
                } else {
                    item = {
                        'id': good.id || '-',
                        'Наименования': good.name,
                        'Себестоимость': good.costprice,
                        'id Ингредиента': raw.id || '-',
                        'Ингредиент': raw.name,
                        'Ед. изм. ингредиента': raw.measure,
                        'Количество ингредиента': roundToFixed(raw.quantity, 3),
                        'Себестоимость ингредиента': roundToFixed(raw.costprice, 4),
                        'Сумма за ингредиент': roundToFixed(raw.sum, 4),
                    }
                }
                return item;
            })
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Себестоимость");

        const filial = point ? this.props.filials.find((item) => item.id === point) : null
        const filialName = filial ? this.renderPointLabel(filial) : '';

        writeFileXLSX(wb, `Себестоимость ${type === 'good' ? 'товары' : 'полуфабрикаты'} ${filialName} с рецептом ${moment().format('DD-MM-YYYY')}.xlsx`);
    }

    onExportsWithRaws = async () => {
        const { type, point } = this.props.costprice.filters;
        const data = await this.props.getGoodsWithReceipe(null, true);
        const goods = data.goods;

        const newRawPrices = await this.getAllRawPrices(goods);
        this.setState({ rawsPrices: { ...this.state.rawsPrices, ...newRawPrices }});

        const goodsWithRaws = (await Promise.all(goods.flatMap(async (good) => {
            const dataPrice = this.getRegionPrice(good);
            if (!good.modifications || good.modifications.length === 0) {
                const costprice = this.getCostPriceGood(good.receipeData, 'default') || '-';

                let item = {
                    id: good.id,
                    name: good.name,
                    costprice,
                    rawData: await this.getExportDataRaws(good.receipeData, 'default'),
                };

                if (type === 'good') {
                    item = {
                        ...item,
                        price: dataPrice,
                        margin: this.getMarginGood(dataPrice, costprice) || '-',
                        extracharge: this.getExtrachargeGood(dataPrice, costprice) || '-',
                    }
                }

                return [item];
            }
            
            const modItems = await Promise.all(good.modifications.map(async (mod) => {
                const idMod = !mod.default ? mod.id : 'default';
                const price = this.getPriceGood({ ...good, price: dataPrice}, idMod);
                const costprice = this.getCostPriceGood(good.receipeData, idMod) || '-';

                let item = {
                    id: mod.default ? good.id : `${good.id}_${mod.id}`,
                    name: `${good.name} ${mod.title}`,
                    costprice,
                    rawData: await this.getExportDataRaws(good.receipeData, idMod),
                };

                if (type === 'good') {
                    item = {
                        ...item,
                        price,
                        margin: this.getMarginGood(price, costprice) || '-',
                        extracharge: this.getExtrachargeGood(price, costprice) || '-',
                    }
                }

                return item;
            }));

            return modItems;
        }))).flat();

        const exportData = goodsWithRaws.flatMap((good) => {
            if (!good.rawData || good.rawData.length === 0) {
                let item = {
                    'id': good.id || '-',
                    'Наименования': good.name,
                    'Себестоимость': good.costprice,
                    'id Сырья': '-',
                    'Сырье': '-',
                    'Ед. изм. сырья': '-',
                    'Количество сырья': '-',
                    'Себестоимость сырья': '-',
                    'Сумма за сырье': '-',
                }
                if (type === 'good') {
                    item = {
                        ...item,
                        'Цена': good.price || '-',
                        'Маржа': good.margin || '-',
                        'Наценка (%)': good.extracharge || '-',
                        'Себестоимость': good.costprice,
                    }
                }
                return [item];
            }

            return good.rawData.map((raw) => {
                let item = {}
                if (type === 'good') {
                    item = {
                        'id': good.id || '-',
                        'Наименования': good.name,
                        'Цена': good.price || '-',
                        'Маржа': good.margin || '-',
                        'Наценка (%)': good.extracharge || '-',
                        'Себестоимость': good.costprice,
                        'id Сырья': raw.id || '-',
                        'Сырье': raw.name,
                        'Ед. изм. сырья': raw.measure,
                        'Количество сырья': roundToFixed(raw.quantity, 3),
                        'Себестоимость сырья': roundToFixed(raw.last_price, 4),
                        'Сумма за сырье': roundToFixed(raw.sum, 4),
                    }
                } else {
                    item = {
                        'id': good.id || '-',
                        'Наименования': good.name,
                        'Себестоимость': good.costprice,
                        'id Сырья': raw.id || '-',
                        'Сырье': raw.name,
                        'Ед. изм. сырья': raw.measure,
                        'Количество сырья': roundToFixed(raw.quantity, 3),
                        'Себестоимость сырья': roundToFixed(raw.last_price, 4),
                        'Сумма за сырье': roundToFixed(raw.sum, 4),
                    }
                }
                return item;
            })
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Себестоимость");

        const filial = point ? this.props.filials.find((item) => item.id === point) : null
        const filialName = filial ? this.renderPointLabel(filial) : '';

        writeFileXLSX(wb, `Себестоимость ${type === 'good' ? 'товары' : 'полуфабрикаты'} ${filialName} с составом сырья ${moment().format('DD-MM-YYYY')}.xlsx`);
    }

    onExportWithReceipe = async () => {
        if (this.state.typeReceipe === 'receipe' ) return await this.onExportWithIngredients();
        return await this.onExportsWithRaws();
    }

    changeTypeReceipe = (value) => {
        if (this.state.typeReceipe === value) return;
        return this.setState({ typeReceipe: value });
    }

    componentDidMount() {
        if (isEmpty(this.props.categories)) this.props.fetchCategories();
        if (isEmpty(this.props.raws)) this.props.fetchRawsList();
        if (isEmpty(this.props.goodsList)) this.props.fetchGoods();
        if (isEmpty(this.props.filials)) this.props.fetchFilials();
    }

    onChangeSelect = (e, field) => {
        const { filters } = this.props.costprice;
        const updated = { ...filters, [field]: e.value };
        this.props.setStatFilters('costprice', updated);
    }

    categoryOptions = () => {
        const { filters } = this.props.costprice;
        const { type } = filters;

        const categories = type === 'good' ? this.props.categories : this.props.productCategories;
        const options = [
            {value: null, label: 'Все категории'},
            ...categories.map(el => ({
                value: el.id,
                label: el.title,
            })).sort((a, b) => {
                if (a.label < b.label) return -1;
                if (a.label > b.label) return 1;
                return 0;
            })
        ]
        return options;
    }

    renderPointLabel = (point) => {
        if (!point) return '';
        return `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    }

    pointOptions = () => {
        const options = [
            { value: null, label: 'Все филиалы' },
            ...this.props.filials.map((el) => ({
                value: el.id,
                label: this.renderPointLabel(el),
                enableConsumption: el.enableConsumption,
            })).sort((a, b) => {
                if (a.label < b.label) return -1;
                if (a.label > b.label) return 1;
                return 0;
            })
        ]
        return options;
    }

    renderHead() {
        const { filters } = this.props.costprice;

        const typeOptions = [
            { label: 'Товары', value: 'good' },
            { label: 'Полуфабрикаты', value: 'semi' },
        ];

        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Себестоимость по товарам и п/ф
                    </h3>
                </div>
                <div className="kt-portlet__head-toolbar" style={{ alignItems: 'start', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <Select
                            isLoading={this.props.loadingFilials}
                            isDisabled={this.props.loadingFilials}
                            placeholder='Тип'
                            value={typeOptions.find((option) => option.value === filters.type)}
                            onChange={(e) => this.onChangeType(e)}
                            options={typeOptions}
                        />
                    </div>
                    <div style={{ width: 200 }}>
                        <Select
                            isLoading={this.props.loadingFilials}
                            isDisabled={ this.props.loadingFilials}
                            value={filters.category ? this.categoryOptions().find((category) => category.id === filters.category) : null}
                            placeholder='Категория'
                            onChange={(e) => this.onChangeSelect(e, 'category')}
                            options={this.categoryOptions()}
                        />
                    </div>
                    <div style={{ width: 200 }}>
                        <Select
                            isLoading={this.props.loadingFilials}
                            isDisabled={this.props.loadingFilials}
                            value={filters.point ? this.pointOptions().find((point) => point.id === filters.point) : null}
                            placeholder='Филиал'
                            onChange={(e) => this.onChangeSelect(e, 'point')}
                            options={this.pointOptions()}
                        />
                    </div>
                    <button className='btn btn-primary' onClick={this.onSearch}> Найти </button>
                    <button className='btn btn-success' onClick={this.onExport}> Экспорт </button>
                    <button className='btn btn-success' onClick={this.onExportWithReceipe}> Экспорт с составом </button>
                </div>
                <div className="kt-portlet__head-toolbar" style={{ width: '200px', justifyContent: 'space-between', alignItems: 'center' }}>
                    Состав:
                    <button onClick={() => this.changeTypeReceipe('receipe')} className={`btn btn-sm btn-${this.state.typeReceipe === 'receipe' ? 'primary' : 'secondary'}`}>Рецепт</button>
                    <button onClick={() => this.changeTypeReceipe('raw')} className={`btn btn-sm btn-${this.state.typeReceipe === 'raw' ? 'primary' : 'secondary'}`}>Сырье</button>
                </div>
            </div>
        );
    }

    handlePageClick = (data) => {
        const { filters } = this.props.costprice;
        this.setState({ currentPage: data.selected });
        let nextStart = data.selected * filters._limit;
        const updated = { ...filters, _start: nextStart, };
        this.props.setStatFilters('costprice', updated);
        this.onSearch(updated);
    };

    chekMarginPagesDisplayed() {
        const userDisplayWidth = window.innerWidth;
        if (userDisplayWidth < 400) return 1;
        if (userDisplayWidth < 550) return 2;
        if (userDisplayWidth < 850) return 3;
        if (userDisplayWidth < 1250) return 5;
        return 8;
    }

    chekPageRangeDisplayed() {
        const userDisplayWidth = window.innerWidth;
        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        return 5;
    }

    renderPagination() {
        const { filters } = this.props.costprice;
        const pages = Math.ceil(+this.state.count / +filters._limit);
        if (!this.state.data) return;

        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded order_table">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={this.chekMarginPagesDisplayed()}
                    pageRangeDisplayed={this.chekPageRangeDisplayed()}
                    forcePage={this.state.currentPage}
                    onPageChange={this.handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />

                    <div className="kt-datatable__pager-info">
                        {
                            filters._start + filters._limit >= this.state.count ? (
                                <span className="kt-datatable__pager-detail">Показано {filters._start + 1} - {+this.state.count} из {this.state.count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {filters._start + 1} - {+filters._start + +filters._limit} из {this.state.count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }

    getCostPriceGood = (receipeData, field = 'default') => {
        if (!receipeData || receipeData.length === 0) return null;
        
        const sum = receipeData.reduce((acc, item) => {
            const rawData = this.props.raws.find((raw) => raw.id === item.id);
            if (!rawData) return acc;
            
            const key = this.props.costprice.filters.point ? `${item.id}_${this.props.costprice.filters.point}` : item.id;
            const price = roundToFixed(this.state.rawsPrices[key], 4) || roundToFixed(rawData.last_price, 4);
            
            if (item.count && (item.count[field] != null)) {
                const quantity = item.count[field] ? roundToFixed(item.count[field], 3) || 0 : 0;
                acc += price * quantity;
            } else {
                const quantity = item.quantity && item.quantity[field] ? roundToFixed(item.quantity[field], 3) || 0 : 0;
                acc += price * quantity;
            }
            
            return acc;
        }, 0);
        
        return roundToFixed(sum);
    }

    getMarginGood = (price, costprice) => {
        if (!price || !costprice || roundToFixed(costprice) === 0) return '-';
        
        const priceNum = roundToFixed(price);
        const costpriceNum = roundToFixed(costprice);

        const margin = priceNum - costpriceNum;
        const result = Math.round(margin * 100) / 100;

        return roundToFixed(result);
    };

    getExtrachargeGood = (price, costprice, percent) => {
        if (!price || !costprice || roundToFixed(costprice) === 0) return '-';
        
        const priceNum = roundToFixed(price);
        const costpriceNum = roundToFixed(costprice);
        
        const extracharge = ((priceNum - costpriceNum) / costpriceNum) * 100;
        const result = Math.round(extracharge * 100) / 100;
        
        if (percent) return `${roundToFixed(result)}%`;        
        return roundToFixed(result);
    };

    changeModGood = (index, mod) => {
        const { data } = this.state;
        const updated = [ ...data ];
        updated[index].idMod = mod ? mod.id : null;
        this.setState({data: updated})
    }

    getModPrice = (price, mod) => {
        if (mod.price === 0) return 0;
        if (!price) return 0;

        if (mod.condition === 'equal') return roundToFixed(mod.price);
        if (mod.persent) {
            const persentPrice = roundToFixed(Math.round(price * (mod.price / 100)));
            if (mod.condition === 'plus') return roundToFixed(price + persentPrice);
            return roundToFixed(price - persentPrice);
        } else {
            if (mod.condition === 'plus') return roundToFixed(price + mod.price);
            if (mod.condition === 'multiply') return roundToFixed(price * mod.price);
            return roundToFixed(price - mod.price);
        }
    }

    getPriceGood = (good, idMod) => {
        if (!idMod || idMod === 'default') return roundToFixed(good.price);
        const mod = good.modifications.find((item) => item.id === idMod);
        return this.getModPrice(good.price, mod);
    }
 
    showReceipe = (index) => {
        const { data } = this.state;
        const updated = [ ...data ];
        updated[index].showReceipe = true;
        this.setState({data: updated})
    }

    renderReceipeIngredients = (receipe, idMod = 'default') => {
        if (!receipe || !receipe.ingredients) return null;
        
        return receipe.ingredients.map((ingredient) => {
            const receipeData = ingredient.receipeData;
            const arr = ingredient.type === 'good' ? this.props.goodsList : this.props.raws;
            const id = typeof ingredient.id === 'number' ? ingredient.id : +ingredient.id.split('_')[0];
            const modId = typeof ingredient.id === 'number' ? null : +ingredient.id.split('_')[1];
            let item = { ...arr.find((el) => el.id === id) };

            if (modId) {
                const entityMod = item.modifications.find((mod) => mod.id === modId);
                if (entityMod && entityMod.title) item.name = `${item.name} ${entityMod.title}`
            } else {
                if (!isEmpty(item.modifications) && item.modifications.length > 1) {
                    const entityMod = item.modifications.find((mod) => mod.default);
                    if (entityMod && entityMod.title) item.name = `${item.name} ${entityMod.title}`
                }
            }

            if (!item) item = ingredient;

            let costprice;
            if (ingredient.type === 'raw') {
                const key = this.props.costprice.filters.point ? `${item.id}_${this.props.costprice.filters.point}` : item.id;
                costprice = roundToFixed(this.state.rawsPrices[key], 4) || roundToFixed(item.last_price, 4);
            } else {
                costprice = this.getCostPriceGood(receipeData, modId ? modId : 'default');
            }
            
            const quantity = roundToFixed(ingredient.quantity[idMod], 3) || 0;
            if (quantity === 0) return null;
            const sum = (!costprice || !quantity) ? '-' : roundToFixed(costprice * quantity, 4);

            let title = '(п/ф)';
            if (ingredient.type === 'good') title = '(товар)';
            if (ingredient.type === 'raw') title = '(сырье)';


            return (
                <tr className='kt-datatable__row' key={`ingredient-${ingredient.id}-${idMod || 'default'}`}>
                    <td className='kt-datatable__cell' style={{ width: '165px' }}>
                        <span>{`${item.name || 'DELETED'} ${title}`}</span>
                    </td>
                    <td className='kt-datatable__cell' style={{ width: 'auto' }}></td>
                    <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}>
                        <span>{`${quantity} ${ingredient.type === 'good' ? 'шт.' : (MEASURES_RAW[item.measure] || '')}`}</span>
                    </td>
                    <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}>
                        <span>{costprice || '-'}</span>
                    </td>
                    <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}>
                        <span>{sum}</span>
                    </td>
                </tr>
            );
        });
    }

    renderReceipeRaws = (receipeData, idMod) => {
        if (!receipeData) return null;
        
        let items = {};
        receipeData.forEach((ingredient) => {
            let data = items[ingredient.id] || null;
            const raw = this.props.raws.find((item) => item.id === ingredient.id);
            
            if (!data) {
                const key = this.props.costprice.filters.point ? `${ingredient.id}_${this.props.costprice.filters.point}` : ingredient.id;
                const price = this.state.rawsPrices[key] || (raw ? roundToFixed(raw.last_price, 4) : null);
                
                data = {
                    id: ingredient.id,
                    name: raw ? raw.name : ingredient.name || 'DELETED',
                    measure: raw ? raw.measure : null,
                    last_price: price,
                    quantity: 0,
                };
            }

            if (ingredient.count && (ingredient.count[idMod] != null)) {
                data.quantity += roundToFixed(ingredient.count[idMod], 3) || 0;
            } else {
                data.quantity += roundToFixed(ingredient.quantity[idMod], 3) || 0;
            };
            items[ingredient.id] = data;
        });
        
        return Object.values(items).map((item) => {
            if (item.quantity === 0) return null;
            const price = roundToFixed(item.last_price, 4) || 0;
            const sum = (!price || !item.quantity) ? '-' : roundToFixed(price * roundToFixed(item.quantity, 3), 4);

            return (
                <tr className='kt-datatable__row' key={`raw-${item.id}-${idMod || 'default'}`}>
                    <td className='kt-datatable__cell' style={{ width: '165px' }}>
                        <span>{`${item.name}`}</span>
                    </td>
                    <td className='kt-datatable__cell' style={{ width: 'auto' }}></td>
                    <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}>
                        <span>{`${roundToFixed(item.quantity, 3) > 0.001 ? roundToFixed(item.quantity, 3) : '< 0.001'} ${MEASURES_RAW[item.measure] || ''}`}</span>
                    </td>
                    <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}>
                        <span>{roundToFixed(item.last_price, 4) || '-'}</span>
                    </td>
                    <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}>
                        <span>{sum}</span>
                    </td>
                </tr>
            );
        });
    }

    renderReceipe = (good, index) => {
        return (
            <table className='kt-datatable__table' style={{ backgroundColor: '#d5d4ff61'}} key={`receipe-${good.id}-${index}`}>
                <tbody className='kt-datatable__body'>
                    <tr className='kt-datatable__row'>
                        <td className='kt-datatable__cell' style={{ width: '165px' }}> Название </td>
                        <td className='kt-datatable__cell' style={{ width: 'auto' }}></td>
                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Кол-во</span></td>
                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Себестоимость</span></td>
                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Сумма</span></td>
                    </tr>
                    {this.state.typeReceipe === 'receipe' ? this.renderReceipeIngredients(good.receipe, good.idMod) : this.renderReceipeRaws(good.receipeData, good.idMod)}
                </tbody>
            </table>
        );
    }

    renderButtonReceipe = (good, index) => {
        if (good.showReceipe) return null;
        const { typeReceipe } = this.state;
        if (typeReceipe === 'receipe' && (!good.receipe || isEmpty(good.receipe.ingredients))) return null;
        if (typeReceipe === 'raw' && (!good.receipeData || good.receipeData.length === 0)) return null;
        return (
            <button 
                onClick={() => this.showReceipe(index)} 
                className='order_table_button-show-details' 
                style={{ alignItems: 'center', gap: '5px', marginTop: '5px', fontSize: '10px' }}
            >
                Показать состав <i className='kt-menu__ver-arrow la la-angle-down'/>
            </button>
        );
    }

    renderBody() {
        const { loading } = this.props.costprice;
        const { data, renderFields, loadingData, loadingPrices } = this.state;
        const { loadingGoods, loaderList, loadingFilials } = this.props;

        if (loading || loaderList || loadingGoods || loadingData || loadingFilials || loadingPrices) {
            return <div style={styles.loading}><Loader /></div>;
        }
        
        return(
            <>
            <div className="kt-portlet">
                <div className='kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid' style={{ padding: '0px' }}>
                    <div className='kt-portlet kt-portlet--mobile'>
                        <div className='kt-portlet__body kt-portlet__body--fit'> 
                            {this.state.error && 
                                <div style={this.props.style} className='alert fade show alert-outline-danger'>
                                    <div className="alert-icon"><i className="flaticon-warning"></i></div>
                                    <div className="alert-text">{`Ошибка ${this.state.error.statusCode} ${this.state.error.message}`}</div>
                                </div>
                            }
                            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                                <table className='kt-datatable__table'>
                                    {data && <thead className='kt-datatable__head'>
                                        <tr className='kt-datatable__row'>
                                            <th className='kt-datatable__cell' style={{ width: '165px' }}><span>Наименование</span></th>
                                            <th className='kt-datatable__cell' style={{ width: 'auto' }}></th>
                                            {renderFields && 
                                            <>
                                                <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Цена</span></th>
                                                <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Маржа</span></th>
                                                <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Наценка (%)</span></th>
                                            </>
                                            }
                                            <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Себестоимость</span></th>
                                        </tr>
                                    </thead>}
                                    <tbody className='kt-datatable__body'>
                                        {!data || data.length === 0
                                        ? <tr className='kt-datatable__row'><td colSpan="5" style={{ textAlign: 'center' }}>Нет данных</td></tr> 
                                        : data.map((good, index) => {
                                            const costprice = this.getCostPriceGood(good.receipeData, good.idMod ? good.idMod : 'default');
                                            const price = !good.idMod ? parseNumToFixed(good.price) : this.getPriceGood(good, good.idMod);
                                            return (
                                                <React.Fragment key={`good-${good.id}-${good.idMod || 'default'}-${index}`}>
                                                    <tr className='kt-datatable__row'>
                                                        <td className='kt-datatable__cell' style={{ width: '165px' }}>
                                                            <span>{good.name}</span>
                                                            {this.renderButtonReceipe(good, index)}
                                                        </td>
                                                        <td className='kt-datatable__cell' style={{ width: 'auto' }}></td>
                                                        {renderFields && 
                                                        <>
                                                            <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{price || '-'}</span></td>
                                                            <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{this.getMarginGood(price, costprice)}</span></td>
                                                            <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{this.getExtrachargeGood(price, costprice, true)}</span></td>
                                                        </>
                                                        }
                                                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{costprice || '-'}</span></td>
                                                    </tr>
                                                    {good.showReceipe && this.renderReceipe(good, index)}
                                                </React.Fragment>
                                            );
                                        })
                                        }
                                    </tbody>
                                </table>
                                {this.renderPagination()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }

    render() {
        return (
            <>
                <div className="kt-portlet">
                    {this.renderHead()}
                </div>
                {this.renderBody()}
            </>
        );
    }
}

const mapStateToProps = state => {
    return ({
        productCategories: categoriesRawByType('semi')(state),
        categories: categoryListSelector(state),
        costprice: state.statistics.costprice,
        raws: rawListSelector(state),
        loaderList: loaderRawsSelector(state),
        goodsList: state.good.list,
        loadingGoods: state.loaders.goods,
        loadingFilials: state.loaders.filials,
        filials: state.handbook.filials,
    });
};

const mapDispatchToProps = {
    fetchProductCategories: () => fetchProductCategories('semi'),
    fetchCategories: () => fetchCategories(),
    setStatFilters: (name, filters) => setStatFilters(name, filters),
    getGoodsWithReceipe: (good, getAll) => getGoodsWithReceipe(good, getAll),
    getGoodWithReceipeData: (item, getAll) => getGoodWithReceipeData(item, getAll),
    fetchRawsList: () => fetchRawsList(),
    fetchGoods: () => fetchGoods(),
    fetchFilials: () => fetchFilials(null, true),
}

export default connect(mapStateToProps, mapDispatchToProps)(Costprice);